import { UnshadowedElement, html } from "../lib/unshadowed.js";

/**
 * Train info bar that responds to global photo update events
 * Relies on window.CurrentTrain
 */
export class TrainInfoCard extends UnshadowedElement {
    static elementName() { return "train-info-card" }

    static properties = {
        photoUrl: { type: String },
    };

    constructor() {
        super();
        // Defaults
        this.photoUrl = window.CurrentTrain.PhotoUrl;
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("photoUrlChange", e => this.PhotoUrlChanged(e));
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("photoUrlChange", e => this.PhotoUrlChanged(e));
    }

    PhotoUrlChanged(e) {
        this.photoUrl = e.detail.content;
    }

    render() {
        return html`
            <div class="train-info-card">
                ${this.photoUrl ? html`
                    <div class="image-holder">
                        <img src=${this.photoUrl} alt=${window.CurrentTrain.Name} title=${window.CurrentTrain.Name} />
                    </div>
                ` : html`
                    <div class="image-holder train-thumbnail-photo placeholder" data-placeholder-id=${window.CurrentTrain.Id.charCodeAt(0) % 4}></div>
                `}
                <div class="card-content">
                    <p>
                        ${window.CurrentTrain.Type} for
                        <span class="name strong">${window.CurrentTrain.Name}</span>
                    </p>
                </div>
            </div>
        `;
    }
}
